<script>
  import crud from './Base/Crud'
  export default {
    mixins: [crud],
    data() {
      return {
        url: '/log/system',
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          editBtn: true, // 修改按钮显隐
          delBtn: true, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '管理员',
              prop: 'admin_id',
              type: 'select',
              props: {
                label: 'username',
                value: 'id'
              },
              dicUrl: this.config.baseURL + '/dic/admin',
              // 以下两个属性同时使用可以彻底不在列表中显示
              hide: true, // 隐藏列
              showColumn: false // 是否加入动态现隐列
            },
            {
              label: '修改管理员note',
              prop: 'admin-notes',
            },
            {
              label: '类型',
              prop: 'method',
              type: 'radio',
              dicData: [{label: 'GET', value: 'GET'}, {label: 'POST', value: 'POST'}],
              row:true
            },
            {
              label: '跨表查询',
              display: false, // 全部不可见
              searchSpan: 4,
              prop: 'admin-username',
              search: true,
            },
            {
              label: '标题1-n',
              prop: 'details-title',
              type: 'select',
              allowCreate: true, // 允许添加条目
              filterable: true, // 级联框是否可以搜索
              multiple: true, // 多选
              row: true,
              // defaultFirstOption: true, // 回车选中
            },
            {
              label: '描述1-n',
              prop: 'details-desc',
              type: 'select',
              allowCreate: true, // 允许添加条目
              filterable: true, // 级联框是否可以搜索
              multiple: true, // 多选
              row: true,
              // defaultFirstOption: true, // 回车选中
            },
            {
              label: '用户n-n',
              prop: 'users-id',
              type: 'checkbox',
              row: true,
              multiple: true, // 多选
              props: {
                label: 'username',
                value: 'id'
              },
              dicUrl: this.config.baseURL + '/dic/users',
            },
            {
              label: 'url',
              value: 'abc.com',
              prop: 'path'
            },
            {
              label: 'ip',
              value: '192.168.1.1',
              prop: 'ip'
            },
            {
              label: '数据',
              prop: 'input',
              value: '{测试数据}',
              // 以下两个属性同时使用可以彻底不在列表中显示
              hide: true, // 隐藏列
            },
            {
              label: '操作时间',
              prop: 'created_at',
              type: 'datetimerange',
              format: 'yyyy-MM-dd HH:mm:ss',
              // valueFormat: 'yyyy-MM-dd HH:mm:ss',
              display: false,
              searchSpan: 10,
              searchRange: true,
              search: true
            }
          ]
        }
      }
    }
  }
</script>
